// /src/pages/private/members/dashboard/dashboardRankProgressionApi.js

import axios from 'axios';

/** @param {number} handleId */
export async function fetchDashboardRankProgression(handleId) {
  const { data } = await axios.post(
    '/api/user/private-dashboard/rank-progression',
    { handleId },
    { withCredentials: true },
  );
  return data;
}
